import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import React from "react";
import {
  Col,
  Container,
  Row,
  Input,
  Button,
  Card,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
} from "reactstrap";
import find from "../../../assets/find.svg";
import "simplebar/dist/simplebar.min.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import Placeholder from "../../../assets/images/Placeholder.gif";
import moreIcon from "../../../assets/images/more.png";
import check from "../../../assets/images/check.svg";
import caldropdown from "../../../assets/images/cal-dropdown.svg";
import { get, del, put } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import { useSelector } from "react-redux";

const PassesListing = () => {
  document.title = "Passes Listing | Elevated - Admin Dashboard";
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const gymId = searchParams.get("gymId") || null;

  const [dropdownOpen, setDropdownOpen] = useState({
    selectGym: false,
    dateRange: false,
    byLocation: false,
    mostLoved: false,
  });
  const [passesData, setPassesData] = useState([]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState("");
  const [itemPerPage, setItemPerPage] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [selectedType, setSelectedType] = useState("By Type");
  const [endSearchDate, setEndSearchDate] = useState("");
  const itemsPerPage = 6;
  const [startSearchDate, setStartSearchDate] = useState("");
  const { currentUser } = useSelector((state) => state.auth);

  const [selectedGym, setSelectedGym] = useState("");
  const [gymData, setGymData] = useState([]);
  const [seletedGymId, setSeletedGymId] = useState(gymId);
  const gymIds = async () => {
    const resp = await get(
      `${endpoints.gym}/admin?userId=${currentUser.id}&limit=50`
    );
    if (resp?.data?.success) {
      setGymData(resp.data.data);

      let temp = resp?.data?.data.filter((item) => item._id == gymId);

      setSelectedGym(temp[0]?.name || resp?.data?.data[0]?.name);
      setSeletedGymId(gymId ? gymId : resp?.data?.data[0]?._id);
    }
  };

  useEffect(() => {
    if (
      currentUser.appRole == "gymOwner" ||
      currentUser.appRole == "gymStaff"
    ) {
      gymIds();
    }
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  const toggleDropdown = (passId) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [passId]: !prevState[passId],
    }));
  };

  const fetchPasses = async (page, searchQuery = "") => {
    setLoading(true);
    try {
      const response = await get(
        `${
          endpoints.pass
        }?filter=active&limit=${itemsPerPage}&page=${page}&type=${
          selectedType == "By Type" ? "" : selectedType
        }&search=${searchQuery}&startDate=${startSearchDate}&endDate=${endSearchDate}&gymId=${
          seletedGymId != "null" && seletedGymId != null ? seletedGymId : gymId
        }`
      );

      setPassesData(
        Array.isArray(response.data?.data) ? response.data.data : []
      );
      setTotalPages(response.data?.totalPages || 1);
      setItemPerPage(response.data?.data?.length || 0);
      setTotalItems(response.data?.totalCount || 0);
    } catch (error) {
      setPassesData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPasses(currentPage, debouncedSearchTerm);
  }, [currentPage, debouncedSearchTerm, seletedGymId, selectedType]);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const navigate = useNavigate();

  const handleSelectChange = async (action, passId) => {
    switch (action) {
      case "delete":
        await deletePass(passId);
        break;
      case "update":
        const updatedData = {};
        await updatePass(passId, updatedData);
        break;

      default:
        break;
    }
  };

  const handleEditPass = (passId, gymId) => {
    navigate(`/add-passes?passId=${passId}&gymId=${gymId}`);
  };

  const deletePass = async (passId) => {
    try {
      await del(`${endpoints.pass}/${passId}`);
      setPassesData((prevData) =>
        prevData.filter((pass) => pass.id !== passId)
      );
      fetchPasses(currentPage);

      toast.success(`Pass Deleted Successfully`, {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
    } catch (error) {}
  };
  const updatePass = async (passId, updatedData) => {
    try {
      await put(`${endpoints.pass}/${passId}`, updatedData);
      fetchPasses(currentPage, searchTerm);
    } catch (error) {}
  };
  const handlePassDetail = async (passId) => {
    try {
      const response = await get(`${endpoints.pass}/${passId}`);
      navigate(`/pass-detail`, { state: { passData: response.data } });
    } catch (error) {}
  };
  const handleClearDates = () => {
    setStartDate("");
    setEndDate("");
    fetchPasses(currentPage, debouncedSearchTerm);
    setEndSearchDate("");
    setStartSearchDate("");
    setSelectedType("By Type");
    setSearchTerm("");
    setCurrentPage(1);
  };
  const handleClearFilters = () => {
    setSelectedType("By Type");
    setSearchTerm("");
    setCurrentPage(1);
  };
  function formatDate(date) {
    try {
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      return new Date(date)
        .toLocaleDateString("en-CA", options)
        .replace(/\//g, "-");
    } catch (err) {
      console.error("Error", err);
    }
  }
  useEffect(() => {
    if (startSearchDate != "" && endSearchDate != "") {
      fetchPasses(currentPage, debouncedSearchTerm);
    }
    fetchPasses(currentPage, debouncedSearchTerm);
  }, [startSearchDate, endSearchDate]);
  const formatNumber = (num) => {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(2) + "B";
    } else if (num >= 1000000) {
      return (num / 1000000).toFixed(2) + "M";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(2) + "K";
    }
    return num.toFixed(2);
  };
  return (
    <div className="">
      <Container fluid>
        <Row>
          <Col>
            <Card className="rounded-4">
              <CardBody>
                <div className="d-flex flex-column flex-xxl-row justify-content-between align-items-center mb-3">
                  {/* Search Section */}
                  <div className="d-flex flex-column flex-lg-row justify-content-start align-items-center gap-2 w-100 mt-2 mt-sm-0 mb-0 mb-md-2">
                    <span className="font-size-20 fw-bold primary-black ff-sora mb-2 mb-sm-0">
                      Passes
                    </span>
                    <div
                      className="w-100 w-sm-auto mx-sm-3 bg-light ff-sora d-flex justify-content-between align-items-center"
                      style={{
                        borderRadius: "12px",
                        height: "48px",
                        minWidth: "200px",
                      }}
                    >
                      <img
                        src={find}
                        alt="Search"
                        className="light-black"
                        style={{
                          height: "24px",
                          width: "24px",
                          marginLeft: "10px",
                        }}
                      />
                      <Input
                        type="text"
                        name="search"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="ff-sora light-black font-size-14 fw-normal w-100"
                        style={{
                          background: "transparent",
                          border: "none",
                          minHeight: "",
                        }}
                        placeholder="Search"
                      />
                    </div>
                  </div>

                  {/* Filters and Add New Button Section */}
                  <div className="d-flex flex-column flex-xl-row gap-2 w-100 mt-2 mt-xl-0">
                    <div className="d-flex flex-column flex-md-row gap-2 w-100">
                      {/* Gym Dropdown */}
                      {(currentUser.appRole === "gymOwner" ||
                        currentUser.appRole === "gymStaff") && (
                        <Dropdown
                          isOpen={dropdownOpen.selectGym}
                          toggle={() => toggleDropdown("selectGym")}
                          className="w-100 w-md-auto"
                        >
                          <DropdownToggle
                            caret
                            className="filter-btn d-flex justify-content-between align-items-center w-100 w-xs-auto"
                          >
                            <span className="w-100 w-xs-auto">
                              {selectedGym?.length > 10
                                ? selectedGym.substring(0, 10)
                                : selectedGym}
                              <small style={{ fontSize: "9px" }}>
                                (Selected GYM)
                              </small>
                            </span>
                            <img src={check} alt="Location" className="ms-2" />
                          </DropdownToggle>
                          <DropdownMenu style={{ zIndex: 1 }}>
                            {gymData.map((item, index) => (
                              <DropdownItem
                                key={index}
                                className="fw-normal ff-sora secondary-black font-size-14"
                                onClick={(e) => {
                                  setSelectedGym(item.name);
                                  setSeletedGymId(item._id);
                                }}
                              >
                                {item.name}
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </Dropdown>
                      )}

                      {/* Date Range Dropdown */}
                      <Dropdown
                        isOpen={dropdownOpen.dateRange}
                        toggle={() => toggleDropdown("dateRange")}
                        className="w-100 w-md-auto"
                      >
                        <DropdownToggle
                          caret
                          className="filter-btn d-flex justify-content-between align-items-center w-100 w-xs-auto"
                        >
                          <span className="fw-normal ff-sora secondary-black font-size-14 w-100 w-xs-row">
                            Date Range
                          </span>
                          <img
                            src={caldropdown}
                            alt="Calendar Dropdown"
                            className="ms-2"
                          />
                        </DropdownToggle>
                        <DropdownMenu style={{ zIndex: 2 }} className="p-3">
                          <div className="d-flex flex-column">
                            <span className="mb-2 fw-normal ff-sora secondary-black font-size-14">
                              Start Date
                            </span>
                            <DatePicker
                              selected={startDate}
                              onChange={(date) => {
                                setStartDate(date);
                                setStartSearchDate(formatDate(date));
                              }}
                              dateFormat="yyyy/MM/dd"
                              className="form-control fw-normal ff-sora secondary-black font-size-14 mb-3"
                              placeholderText="Select Start Date"
                            />
                            <span className="mb-2 fw-normal ff-sora secondary-black font-size-14">
                              End Date
                            </span>
                            <DatePicker
                              selected={endDate}
                              onChange={(date) => {
                                setEndDate(date);
                                setEndSearchDate(formatDate(date));
                              }}
                              dateFormat="yyyy/MM/dd"
                              className="form-control fw-normal ff-sora secondary-black font-size-14"
                              placeholderText="Select End Date"
                            />
                          </div>
                          <button
                            type="button"
                            onClick={handleClearDates}
                            className="btn btn-link text-danger fw-normal ff-sora font-size-12 mt-2 p-0"
                          >
                            Clear
                          </button>
                        </DropdownMenu>
                      </Dropdown>

                      {/* Type Dropdown */}
                      <Dropdown
                        isOpen={dropdownOpen.byType}
                        toggle={() => toggleDropdown("byType")}
                        className="w-100 w-md-auto"
                      >
                        <DropdownToggle
                          caret
                          className="filter-btn d-flex justify-content-between align-items-center w-100 w-xs-auto"
                        >
                          <span className="w-100 w-md-auto">
                            {selectedType}
                          </span>
                          <img src={check} alt="Location" className="ms-2" />
                        </DropdownToggle>
                        <DropdownMenu style={{ zIndex: 1 }}>
                          <DropdownItem
                            className="fw-normal ff-sora secondary-black font-size-14 "
                            onClick={handleClearFilters}
                          >
                            By Type
                          </DropdownItem>
                          <DropdownItem
                            className="fw-normal ff-sora secondary-black font-size-14"
                            onClick={() => {
                              setCurrentPage(1);
                              setSelectedType("oneday");
                            }}
                          >
                            One day
                          </DropdownItem>
                          <DropdownItem
                            className="fw-normal ff-sora secondary-black font-size-14"
                            onClick={() => {
                              setCurrentPage(1);
                              setSelectedType("oneweek");
                            }}
                          >
                            One Week
                          </DropdownItem>
                          <DropdownItem
                            className="fw-normal ff-sora secondary-black font-size-14"
                            onClick={() => {
                              setCurrentPage(1);
                              setSelectedType("onemonth");
                            }}
                          >
                            One Month
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>

                    {/* Add New Button */}
                    <div className="d-flex flex-column flex-sm-row gap-2 w-100 mt-1 mt-sm-0">
                      <Button
                        className="rounded-pill1 w-auto w-md-100"
                        color="white"
                        onClick={handleClearDates}
                      >
                        Clear
                      </Button>
                      {currentUser.userPermissions?.passes?.["Create Pass"] && (
                        <Button
                          className="rounded-pill w-auto w-md-100 mt-1 mt-xl-0"
                          onClick={() => {
                            console.log(
                              gymId,
                              seletedGymId,
                              "seletedGymId",
                              gymId != null ? gymId : seletedGymId,
                              typeof gymId,
                              gymId != null ? gymId : seletedGymId
                            );
                            navigate(
                              `/add-passes?gymId=${
                                gymId != null ? gymId : seletedGymId
                              }`
                            );
                          }}
                        >
                          Add New
                        </Button>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="table-responsive hide-scrollbar rounded-4"
                  style={{
                    height: passesData?.length > 0 ? "500px" : "auto",
                  }}
                >
                  <Table
                    hover
                    className="table-borderless table-centered table-nowrap"
                  >
                    <thead>
                      <tr>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Pass ID
                        </th>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Pass Title
                        </th>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Pass Type
                        </th>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Pass Price
                        </th>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          PlatForm Fee (10%)
                        </th>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Platform Discount (10%)
                        </th>

                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Gym Revenue
                        </th>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Total Sold
                        </th>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Added On
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan={8} className="text-center">
                            <div className="d-flex justify-content-center align-items-center">
                              <div
                                className="spinner-border"
                                style={{
                                  width: "3rem",
                                  height: "3rem",
                                  color: "#3BABA6",
                                }}
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : passesData.length === 0 ? (
                        <></>
                      ) : (
                        passesData.map((pass, index) => (
                          <tr key={pass.id}>
                            <td className="fw-normal ff-sora secondary-black font-size-14">
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>
                            <td className="fw-normal ff-sora secondary-black font-size-14">
                              {pass.name || "N/A"}
                            </td>
                            <td className="fw-normal ff-sora secondary-black font-size-14">
                              {pass.duration === "oneday"
                                ? "One Day"
                                : pass.duration === "oneweek"
                                ? "One Week"
                                : pass.duration === "onemonth"
                                ? "One Month"
                                : "N/A"}
                            </td>
                            <td className="fw-normal ff-sora secondary-black font-size-14">
                              <span>
                                ${formatNumber(parseFloat(pass?.price)) || "0"}
                              </span>
                            </td>
                            <td className="fw-normal ff-sora secondary-black font-size-14">
                              <span>
                                $
                                {formatNumber(parseFloat(pass?.platformFee)) ||
                                  "0"}
                              </span>
                            </td>

                            <td className="fw-normal ff-sora secondary-black font-size-14">
                              <span>
                                $
                                {formatNumber(parseFloat(pass?.price * 0.1)) ||
                                  "0"}
                              </span>
                            </td>

                            <td className="fw-normal ff-sora secondary-black font-size-14">
                              <span>
                                ${formatNumber(parseFloat(pass?.gymFee)) || "0"}
                              </span>
                            </td>
                            <td className="fw-normal ff-sora secondary-black font-size-14">
                              {pass?.buyCount}
                            </td>
                            <td className="fw-normal ff-sora secondary-black font-size-14">
                              {pass.createdAt
                                ? new Date(pass.createdAt).toLocaleDateString()
                                : "N/A"}
                            </td>
                            <td>
                              {/* Dropdown for each pass */}
                              <Dropdown
                                isOpen={dropdownOpen[pass.id]}
                                toggle={() => toggleDropdown(pass.id)}
                                direction="down"
                              >
                                <DropdownToggle
                                  tag="button"
                                  className="btn btn-link p-0 w-100 w-xs-auto"
                                >
                                  <img src={moreIcon} alt="More options" />
                                </DropdownToggle>
                                <DropdownMenu end>
                                  {currentUser.userPermissions?.passes?.[
                                    "Update Pass"
                                  ] && (
                                    <DropdownItem
                                      className="fw-normal ff-sora secondary-black font-size-14"
                                      onClick={() =>
                                        handleEditPass(pass.id, pass.gymId)
                                      }
                                    >
                                      Edit Pass
                                    </DropdownItem>
                                  )}
                                  {currentUser.userPermissions?.passes?.[
                                    "Delete Pass"
                                  ] && (
                                    <DropdownItem
                                      className="fw-normal ff-sora secondary-black font-size-14"
                                      onClick={() =>
                                        handleSelectChange("delete", pass.id)
                                      }
                                    >
                                      Delete Pass
                                    </DropdownItem>
                                  )}
                                  <DropdownItem
                                    className="fw-normal ff-sora secondary-black font-size-14"
                                    onClick={() => handlePassDetail(pass.id)}
                                  >
                                    Pass Detail
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                  {!loading && passesData.length === 0 && (
                    <div className="d-flex flex-column align-items-center justify-content-center vh-50">
                      <img
                        src={Placeholder}
                        alt="No record placeholder"
                        className="object-fit-contain img-fluid h-25 w-25 rounded-3 mb-3"
                      />
                      <p className="mt-3 ff-sora font-size-16 fw-normal">
                        No Record Found!
                      </p>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>

            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "40px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
                backgroundColor: "#f5f5f5",
              }}
            >
              <div>
                <span className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                  {`Showing ${Math.min(
                    (currentPage - 1) * itemsPerPage + itemPerPage
                  )} of ${totalItems}`}
                </span>
              </div>
              <div className="d-flex justify-content-center">
                <Button
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor: currentPage === 1 ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lt;
                </Button>
                {[...Array(totalPages).keys()]
                  .slice(
                    Math.max(0, currentPage - 2),
                    Math.min(totalPages, currentPage + 1)
                  )
                  .map((page) => (
                    <Button
                      key={page + 1}
                      onClick={() => handlePageChange(page + 1)}
                      style={{
                        width: "40px",
                        height: "40px",
                        color: currentPage === page + 1 ? "white" : "#1f1f1f",
                        background:
                          currentPage === page + 1 ? "#3BABA6" : "#f5f5f5",
                        marginLeft: "10px",
                        marginRight: "10px",
                        borderRadius: "80px",
                        border: 0,
                      }}
                      className={currentPage === page + 1 ? "active" : ""}
                    >
                      {page + 1}
                    </Button>
                  ))}
                <Button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor:
                      currentPage === totalPages ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                >
                  &gt;
                </Button>
              </div>
            </div>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "60px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
              }}
            ></div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PassesListing;
